import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTASection() {
  return (
    <section className="relative overflow-hidden py-24 lg:py-36">
      {/* The image layer is masked to transparent at the top/bottom so the real
          page background shows through — no color-matching overlay needed, so
          there is never a visible seam regardless of the image's brightness. */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://cdn.builder.io/api/v1/image/assets%2F2651dca913d34eafa320b193e1b2c34e%2Fcb5b778c5f6545c2a42245e5bf2b03c8')",
          WebkitMaskImage:
            "linear-gradient(to bottom, transparent 0%, black 28%, black 76%, transparent 100%)",
          maskImage:
            "linear-gradient(to bottom, transparent 0%, black 28%, black 76%, transparent 100%)",
        }}
      />

      <div className="relative container mx-auto px-4 lg:px-8">
        <div className="relative rounded-3xl border border-white/10 bg-[#06141d]/55 backdrop-blur-xl overflow-hidden shadow-2xl shadow-black/30">
          {/* Ambient glows */}
          <div className="absolute -top-10 -left-10 w-72 h-72 rounded-full bg-primary/20 blur-3xl animate-cta-float-1" />
          <div className="absolute -bottom-10 -right-10 w-80 h-80 rounded-full bg-accent/15 blur-3xl animate-cta-float-2" />

          <div className="relative grid lg:grid-cols-[1fr_480px] items-stretch gap-10 p-8 lg:p-14">
            {/* Content */}
            <div className="text-center lg:text-left lg:self-center">
              <span className="eyebrow">For MedSpa Owners</span>
              <h2 className="mt-4 font-display text-3xl lg:text-5xl font-extrabold tracking-tight text-foreground mb-4">
                Own a MedSpa?
              </h2>
              <p className="text-muted-foreground max-w-lg mb-8 text-lg lg:mx-0 mx-auto">
                Join thousands of providers already listed on MedSpa Directory Pro and reach millions of potential patients.
              </p>
              <div className="flex flex-col sm:flex-row items-center lg:justify-start justify-center gap-3">
                <Link
                  to="/register"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-gradient-to-r from-teal-400 to-sky-400 text-[#031017] font-bold hover:opacity-90 transition-opacity"
                >
                  Get Listed Today
                  <ArrowRight className="w-4 h-4" />
                </Link>
                <Link
                  to="/map"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-white/5 text-foreground font-semibold border border-white/15 hover:border-primary/30 transition-colors"
                >
                  View Map
                </Link>
              </div>
            </div>

            {/* Image */}
            <div className="hidden lg:block rounded-2xl overflow-hidden border border-white/10 min-h-[340px]">
              <img
                src="https://cdn.builder.io/api/v1/image/assets%2F2651dca913d34eafa320b193e1b2c34e%2Fcc449eaa12f04ec8a633e5d5dc5c0623"
                alt="MedSpa Directory Pro reception"
                width={600}
                height={400}
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
